export function setCurrentRight(newCurrentRights) {

  return {
    type: 'SET_CURRENT_RIGHT',
    payload: newCurrentRights
  }
}
